var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4901 2.53391L2.59836 13.004C2.22486 13.4015 1.86341 14.1847 1.79112 14.7269L1.34533 18.6305C1.1887 20.0402 2.20077 21.0041 3.59838 20.7631L7.47796 20.1004C8.02013 20.0041 8.77918 19.6065 9.15268 19.1968L19.0444 8.72678C20.7553 6.91952 21.5264 4.85925 18.8637 2.34114C16.213 -0.152877 14.201 0.726655 12.4901 2.53391Z",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7422 3.37671C12.2603 6.70206 14.9592 9.24427 18.3086 9.58162",
    stroke: "#222222",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderPencil);
export default __webpack_public_path__ + "static/media/icon_header_pencil.56949fb208c5a7bac8419ba76e4b3085.svg";
export { ForwardRef as ReactComponent };